import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
import '../../assets/scripts/myNiceScroll'
import {resizeScroll} from '../../assets/scripts/myNiceScroll'

$(document).ready(function(){
  $('.lawyer-banner').addClass('active')
  if($('.field-case-list ul li').length <= 6){
    $('.field-case').addClass('show-all')
  }
})

// 简历切换
var tabswiper = new Swiper(".section1 .left-swiper .mySwiper", {
  autoHeight: true, //高度随内容变化
  allowTouchMove: false,
  effect : 'fade',
  fadeEffect: {
    crossFade: true,
  },
  on: {
    init: function(swiper){
      $('.section1 .left-tab span').eq(0).addClass('active')
    }, 
    transitionStart: function(swiper){
      $('.section1 .left-tab span').eq(this.realIndex).addClass('active').siblings().removeClass('active')
    },
    transitionEnd: function(swiper){
      resizeScroll ()
    },
  },
});
$('.section1 .left-tab span').hover(function(){
  let index = $(this).index()
  tabswiper.slideTo(index)
})


//代表案例显示全部
$('.field-case .more-cont .common-more-btn').on('click',function(){
  $('.field-case').addClass('show-all')
  resizeScroll()
})


// 最新研究查看更多
if($(window).width() > 992){
  var cmListinitshowliNum = 3
  var cmListshowstep = 3
}else{
  var cmListinitshowliNum = 2
  var cmListshowstep = 2
}
var cmListclickNum = 0
var cmListtotalli = $('.common-list ul li').length

if (cmListtotalli <= 3 && $(window).width() > 992 || cmListtotalli <= 2 && $(window).width() <= 992) {
    $('.common-list .common-more-btn').hide()
}

$('.common-list .common-more-btn').on('click', function () {
  cmListclickNum += 1
    if (cmListinitshowliNum + cmListshowstep * cmListclickNum < cmListtotalli) {
        for (let i = 0; i < cmListshowstep; i++) {
            $('.common-list ul li').eq(cmListinitshowliNum + (cmListclickNum - 1) * cmListshowstep + i).show()
        }
    } else {
        for (let i = 0; i < cmListtotalli - cmListclickNum * cmListshowstep; i++) {
            $('.common-list ul li').eq(cmListinitshowliNum + (cmListclickNum - 1) * cmListshowstep + i).show()
        }
        $('.common-list .common-more-btn').hide()
    }
    resizeScroll()
})


// 相关动态查看更多
var partyinitshowliNum = 2
var partyshowstep = 2
var partyclickNum = 0
var partytotalli = $('.party-building-list ul li').length

if (partytotalli <= partyinitshowliNum) {
  $('.section4 .common-more-btn').hide()
}

$('.section4 .common-more-btn').on('click', function () {
  partyclickNum += 1
  if (partyinitshowliNum + partyshowstep * partyclickNum < partytotalli) {
    for (let i = 0; i < partyshowstep; i++) {
      $('.party-building-list ul li').eq(partyinitshowliNum + (partyclickNum - 1) * partyshowstep + i).show()
    }
  } else {
    for (let i = 0; i < partytotalli - partyclickNum * partyshowstep; i++) {
      $('.party-building-list ul li').eq(partyinitshowliNum + (partyclickNum - 1) * partyshowstep + i).show()
    }
    $('.section4 .common-more-btn').hide()
  }
  resizeScroll()
})
